module.exports = ".bodyClassCustom {\n  background-color: white !important; }\n"